import { message } from "antd";
import {
  HOME_BANNER_UPLOAD_REQUEST,
  HOME_BANNER_UPLOAD_SUCCESS,
  HOME_BANNER_UPLOAD_FAIL,
  HOME_BANNER_FETCH_REQUEST,
  HOME_BANNER_FETCH_SUCCESS,
  HOME_BANNER_FETCH_FAIL,
  HOME_BANNER_DELETE_REQUEST,
  HOME_BANNER_DELETE_SUCCESS,
  HOME_BANNER_DELETE_FAIL,
} from "../../constants/admin/homeBannerConstants";
import axios from "../../../axiosInstance";

// 🔹 Upload Home Banner Images
export const uploadHomeBanner = (images) => async (dispatch) => {
  try {
    dispatch({ type: HOME_BANNER_UPLOAD_REQUEST });

    const formData = new FormData();
    images.forEach((image) => {
      formData.append("images", image);
    });

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const { data } = await axios.post(
      "/api/v1/home-banner/upload",
      formData,
      config
    );

    if (data?.success === true) {
          dispatch({ type: HOME_BANNER_UPLOAD_SUCCESS, payload: data });
          message.success(data?.message || "Home banner images added successfully");
        } else {
          throw new Error(data?.message || "Failed to home banner images");
        }
  } catch (error) {
    dispatch({
      type: HOME_BANNER_UPLOAD_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to home banner images"
    );
  }
};

// Fetch Home Banner Images 
export const fetchHomeBanners = () => async (dispatch) => {
  try {
    dispatch({ type: HOME_BANNER_FETCH_REQUEST });

    const { data } = await axios.get("/api/v1/home-banner/get");

    dispatch({ type: HOME_BANNER_FETCH_SUCCESS, payload: data.homeBanner });
  } catch (error) {
    dispatch({
      type: HOME_BANNER_FETCH_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
  }
};

// 🔹 Delete Home Banner Image
export const deleteHomeBanner = (publicId) => async (dispatch) => {
  try {
    dispatch({ type: HOME_BANNER_DELETE_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.delete("/api/v1/home-banner/delete", {
      data: { publicId },
      ...config,
    });
    if (data?.success === true) {
      dispatch({ type: HOME_BANNER_DELETE_SUCCESS, payload: data });
      message.success(data?.message || "Home banner image deleted successfully");
    } else {
      throw new Error(data?.message || "Failed to home banner images");
    }
  } catch (error) {
    dispatch({
      type: HOME_BANNER_DELETE_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to home banner images"
    );
  }
};
